import {BIFlowType} from "enum/BIFlowType";
import Platform from "platform/Platform";
import {Configuration} from "core/configuration/Configuration";
import {StoreState} from "core/redux/StoreState";
import Utils from "platform/util/Utils";

export class BIUtil {

    public static addPropProps = (biData: any = {}): void => {
        const {IsPropTrading} = Platform.config<Configuration>();
        if (IsPropTrading) {
            const {
                ActivePropTradingPackage,
                ActivePropTradingAddons,
                IsPropTradingMultiStep,
                PropTradingAddons
            } = Platform.reduxState<StoreState>().deposit;

            biData.Flow = IsPropTradingMultiStep ? BIFlowType.PropMultistep : BIFlowType.PropPopup;
            biData.PackageID = ActivePropTradingPackage?.Id;
            biData.PackageName = ActivePropTradingPackage?.Name;
            biData.AddonIDs = ActivePropTradingAddons;
            if (Utils.isArrayNotEmpty(ActivePropTradingAddons)) {
                biData.AddonNames = PropTradingAddons.filter(addon => ActivePropTradingAddons.indexOf(addon.Id) >= 0).map(addon => addon.Name);
            }
        }
    }
}
